import { render, staticRenderFns } from "./CanvasResult.vue?vue&type=template&id=0bfe1d26&"
import script from "./CanvasResult.vue?vue&type=script&lang=js&"
export * from "./CanvasResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports